module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fnvKl"))).then(() => module.bundle.root('aVi2q'));